module.exports = __webpack_public_path__ + "static/media/lib1.d292f618.jpg";